/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext, Fragment } from "react";
import { Modal, Button as ButtonComponent } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { useAxios } from "utils/CustomHooks";
import { groupBy } from "lodash";
import { ExpandedRowDaily, Button, Toast } from "components";
import { ReactComponent as CircleClose } from "assets/images/circle_close.svg";
import { ReactComponent as ConfirmIcon } from "assets/images/big-tik.svg";
import { BackToDraft } from "Services/Orders";
import { toPersianNum } from "utils/helpers";
import { useHistory, useLocation } from "react-router-dom";
import { GeneralDataContext } from "store/GeneralContext.jsx";
import { UserDataContext } from "store/UserContext.jsx";
import momentJalaali from "jalali-moment";
import { EXPAND_LIST_DAILY_TYPE } from "utils/Constants";
import "./KitchenExpandList.scss";

//TODO: write type for these props
const KitchenExpandListDaily = ({
    list,
    removeFromLocalStorage,
    selectedValues,
    submitDraft,
    handleCloseResetModal,
    showResetModal,
    setShowResetModal,
    isDry,
    confirmBtnText,
    exportExcelBtn,
    draftEnabled,
    directConfirm,
    submitURL,
    getVendorsTotalOrders,
    disableLoadOldData,
    vendorOrderType,
    redirectModalto,
    withoutLocalDraft,
    hasExcelExport,
    currentDayOrderInfo,
    newOrderLoading,
    orderId,
    total,
    showTotalOrders = true,
    setExcelLoading,
}) => {
    const { pathname } = useLocation();
    const isConvertPage = pathname.includes("convertor");
    const [submitOrders, setSubmitOrders] = useAxios();
    const [excelExport, getExcelExpoprt] = useAxios();
    const [saveBtnConvertor, postSaveBtnConvertor] = useAxios();
    const [totalValues, settotalValues] = useState(null);
    const [isClicked, setIsClicked] = useState(null);
    const userData = useContext(UserDataContext);
    const [showToast, setShowToast] = useState({
        show: false,
        message: "",
        status: "success",
    });
    const [tableType, setTableType] = useState(EXPAND_LIST_DAILY_TYPE.b2c);
    const generalContext = useContext(GeneralDataContext);
    const {
        expandTable: { setNumberOfHubs },
    } = generalContext;
    const { type_id, date, day, vendor } = selectedValues;
    const { hubs, vendor_products, orders, super_order_id } = list;
    const { mutate: mutateBackToDraft, loading: BackToDraftLoading } =
        useMutation(BackToDraft, {
            onSuccess: () => {
                setShowToast({
                    show: true,
                    message: "سفارش به وضعیت پیش نویس تغییر پیدا کرد",
                    status: "success",
                });
                setTimeout(() => window.location.reload());
            },
        });

    useEffect(() => {
        const keyDownHandler = (event) => {
            if (
                event.key.toLocaleLowerCase() === "control" ||
                event.keyCode === 17
            ) {
                event.preventDefault();

                setTableType(EXPAND_LIST_DAILY_TYPE.b2b);
            } else if (
                event.key.toLocaleLowerCase() === "shift" ||
                event.keyCode === 16
            ) {
                event.preventDefault();

                setTableType(EXPAND_LIST_DAILY_TYPE.total);
            }
        };

        const keyUpHandler = (event) => {
            event.preventDefault();
            setTableType(EXPAND_LIST_DAILY_TYPE.b2c);
        };

        document.addEventListener("keydown", keyDownHandler);
        document.addEventListener("keyup", keyUpHandler);

        return () => {
            document.removeEventListener("keydown", keyDownHandler);
            document.removeEventListener("keyup", keyUpHandler);
        };
    }, []);

    useEffect(() => {
        calcTotal(foods);
    }, [tableType]);

    // because of using states for props that are being sent from the parent component
    // we should use useEffect for setting the states again :(
    useEffect(() => {
        const itemsList = orders[0].products;
        const groupedProducts = groupBy(itemsList, "product_id");
        const defaultProductsObj = vendor_products?.map((food) => {
            return {
                Title: food.title,
                Items: groupedProducts[food.product_id],
            };
        });
        setFoods(defaultProductsObj);
        calcTotal(defaultProductsObj);
        setNewOrders(itemsList);
    }, [list]);

    const itemsList = orders[0].products;
    const groupedProducts = groupBy(itemsList, "product_id");
    const defaultProductsObj = vendor_products?.map((food) => {
        return {
            Title: food.title,
            Items: groupedProducts[food.product_id],
        };
    });
    const [newOrders, setNewOrders] = useState(itemsList);
    const [showModal, setShowModal] = useState(false);
    const [foods, setFoods] = useState(defaultProductsObj);
    const [, setClickedBtn] = useState();
    const { response, loading } = submitOrders;
    const { response: excelUrl, loading: excelLoading } = excelExport;
    const { response: saveBtnRes, loading: loadingSaveBtn } = saveBtnConvertor;

    useEffect(() => {
        if (saveBtnRes?.status === "OK") {
            setShowToast({
                show: true,
                message: "اطلاعات با موفقیت ذخیره شد!",
            });
            const timeout = setTimeout(() => {
                setShowToast({
                    show: false,
                    message: "",
                });
            }, [500]);

            return () => clearTimeout(timeout);
        }
    }, [saveBtnRes]);

    setExcelLoading && setExcelLoading(excelLoading);
    let history = useHistory();

    const isUpdate =
        orders[0].order_id > 0 ||
        (currentDayOrderInfo && currentDayOrderInfo.order_id > 0);

    useEffect(() => {
        const items = orders[0].products;
        setNewOrders(items);
        getVendorsTotalOrders([]);
        setNewFoods();
    }, [newOrderLoading]);

    useEffect(() => {
        if (response && response.status === "OK") {
            toggleShowModal(true);
            removeFromLocalStorage();
        }
    }, [loading]);

    useEffect(() => {
        //TODO: refactor this section

        function downloadContent() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, 1000);
            });
        }

        async function clickAnchorTagsSequentially(anchorTagIds) {
            for (const id of anchorTagIds) {
                const anchorTag = document.getElementById(id);
                anchorTag.click();
                document.getElementById(id).remove();
                await downloadContent();
            }
        }

        try {
            const keyOfUrls = excelUrl && Object.keys(excelUrl);
            let array = [];
            keyOfUrls?.forEach((item, index) => {
                const idTag = `convertor${index + 1}`;
                let link = document.createElement("a");
                link.href = `${excelUrl[item]}?force_download=true`;
                link.setAttribute("download", `file${index + 1}.csv`);
                link.setAttribute("id", idTag);
                document.body.appendChild(link);
                array.push(idTag);
            });
            clickAnchorTagsSequentially(array);
        } catch (error) {}
    }, [excelUrl]);

    useEffect(() => {
        setNumberOfHubs(hubs.length);
    }, []);

    const setNewFoods = (item) => {
        if (item) {
            let currentIndex = null;
            for (let i = 0; i < foods.length; i++) {
                if (foods[i].Items) {
                    currentIndex = foods[i].Items.findIndex(
                        (foodItem) =>
                            foodItem.hub_id === item.hub_id &&
                            foodItem.product_id === item.product_id
                    );
                }

                if (!!currentIndex) {
                    const newFoods = foods;
                    if (newFoods[i]) {
                        newFoods[i].Items[currentIndex] = item;
                    }
                    setFoods(newFoods);
                    calcTotal(newFoods);
                    break;
                }
            }
        } else {
            setFoods(defaultProductsObj);
            calcTotal(defaultProductsObj);
        }
    };

    const calcTotal = (foodsItem) => {
        const totalOrders = [];
        for (let i = 0; i < hubs.length; i++) {
            let total = 0;
            for (let j = 0; j < foodsItem?.length; j++) {
                let currentIndex;
                if (foodsItem[j].Items) {
                    currentIndex = foodsItem[j].Items.findIndex(
                        (food) => food.hub_id === hubs[i].id
                    );
                } else {
                    currentIndex = -1;
                }
                if (currentIndex > -1) {
                    const foodItem = foodsItem[j]?.Items[currentIndex];

                    if (tableType === EXPAND_LIST_DAILY_TYPE.b2c) {
                        isUpdate
                            ? (total += (foodItem && foodItem.qty_2) || 0)
                            : (total += (foodItem && foodItem.qty) || 0);
                    } else if (tableType === EXPAND_LIST_DAILY_TYPE.b2b) {
                        total += (foodItem && foodItem.b2b_stock) || 0;
                    } else if (tableType === EXPAND_LIST_DAILY_TYPE.total) {
                        isUpdate
                            ? (total +=
                                  (foodItem && foodItem.qty_2) +
                                      foodItem.b2b_stock || foodItem.b2b_stock)
                            : (total +=
                                  (foodItem && foodItem.qty) +
                                      foodItem.b2b_stock || foodItem.b2b_stock);
                    }
                }
            }

            const totalObj = {
                hubID: hubs[i].id,
                hubName: hubs[i].title,
                total: total,
            };
            totalOrders.push(totalObj);
        }
        getVendorsTotalOrders(totalOrders);
        settotalValues(totalOrders);
    };

    const logChangeOrders = (data, qty) => {
        const isDryPath = pathname.includes("dry");
        const isOffline = pathname.includes("offline");
        const items = [...newOrders];
        if (data && qty) {
            const founded = items.findIndex(
                (item) =>
                    item.hub_id === data.hub_id &&
                    item.product_id === data.product_id
            );

            if (isUpdate) {
                items[founded].qty_2 = Number(qty);
            } else {
                items[founded].qty = Number(qty);
            }
            setNewFoods(items[founded]);
            setNewOrders(items);

            // Drafting
            if (orders[0].order_id === 0 || withoutLocalDraft) {
                const draft = isDryPath
                    ? JSON.parse(localStorage.getItem("dry-draft"))
                    : isOffline
                      ? JSON.parse(localStorage.getItem("offline-draft"))
                      : JSON.parse(localStorage.getItem("draft"));
                const now = momentJalaali();
                const draftDate = now.locale("fa").format("jYYYY/jM/jD");
                const draftTime = now.locale("fa").format("hh:mm");
                if (draft !== null) {
                    const fIndex = draft.findIndex(
                        (item) =>
                            item.date === date?.days?.[day - 1].date &&
                            item.vendor_id === vendor.id &&
                            item.type_id === type_id
                    );
                    if (fIndex > -1) {
                        draft[fIndex].orders = orders;
                        localStorage.setItem(
                            isDryPath
                                ? "dry-draft"
                                : isOffline
                                  ? "offline-draft"
                                  : "draft",
                            JSON.stringify(draft)
                        );
                    } else {
                        draft.push({
                            hubs,
                            vendor_products,
                            draftTimeInfo: {
                                draftDate,
                                draftTime,
                            },
                            orders,
                            super_order_id,
                            date: date?.days?.[day - 1].date,
                            vendor_id: vendor.id,
                            type_id,
                        });
                        localStorage.setItem(
                            isDryPath
                                ? "dry-draft"
                                : isOffline
                                  ? "offline-draft"
                                  : "draft",
                            JSON.stringify(draft)
                        );
                    }
                } else {
                    localStorage.setItem(
                        isDryPath
                            ? "dry-draft"
                            : isOffline
                              ? "offline-draft"
                              : "draft",
                        JSON.stringify([
                            {
                                hubs,
                                vendor_products,
                                draftTimeInfo: {
                                    draftDate,
                                    draftTime,
                                },
                                orders,
                                super_order_id,
                                date: date?.days?.[day - 1].date,
                                vendor_id: vendor.id,
                                type_id,
                            },
                        ])
                    );
                }
            }
        }
    };

    const handleSubmit = (extraData) => {
        const { last_modifier, order_id, status } = orders[0];
        if (extraData?.direct_accept) {
            setClickedBtn("directConfirm");
        } else {
            setClickedBtn("confirm");
        }

        let newData = {};

        if (isUpdate) {
            newData = {
                orders: [
                    {
                        products: newOrders,
                        last_modifier: currentDayOrderInfo
                            ? currentDayOrderInfo.last_modifier
                            : last_modifier,
                        // last_modifier,
                        order_id: currentDayOrderInfo
                            ? currentDayOrderInfo.order_id
                            : order_id,
                        status: currentDayOrderInfo
                            ? currentDayOrderInfo.status
                            : status,
                        // status,
                    },
                ],
                super_order_id: currentDayOrderInfo
                    ? currentDayOrderInfo?.super_order_id
                    : super_order_id,
                status: currentDayOrderInfo
                    ? currentDayOrderInfo.status
                    : status,
                // status,
                direct_accept: extraData?.direct_accept,
            };
        } else {
            newData = {
                orders: [
                    {
                        date: date?.days ? date.days[day - 1].date : date,
                        products: newOrders,
                        type_id: type_id,
                    },
                ],
                title: currentDayOrderInfo?.title || date?.title,
                vendor_id: vendor.id,
                direct_accept: extraData?.direct_accept,
            };
        }
        if (pathname.includes("offline")) {
            newData.items_type = 1;
        }

        setSubmitOrders({
            method: isUpdate ? "put" : "post",
            url: submitURL,
            data: newData,
        });
    };

    const toggleShowModal = (show) => {
        setShowModal(show);
    };

    const handleRedirectToList = () => {
        toggleShowModal(false);
        setTimeout(() => {
            history.push({
                pathname: redirectModalto,
                state: { order_type: selectedValues.vendor.order_type },
            });
        }, 500);
    };

    const handleMainColumnsTotal = () => {
        const totalArr = [...totalValues];
        const total = totalArr.reduce((acc, item) => (acc += item.total), 0);
        return total;
    };

    const showRedraftButton =
        (userData[0].role === "superadmin" || userData[0].role === "admin") &&
        !!orderId &&
        pathname.includes("orders-status-detail-daily") &&
        orders[0].status !== 6 &&
        orders[0].status !== 1;
    const exportToExcel = (hubId) => {
        getExcelExpoprt({
            method: "get",
            url: `/admin/order/excel/${orderId}/${hubId}`,
        });
    };

    //TODO: refactor this section
    const exportConvertOrder = () => {
        const newData = {
            orders: [
                {
                    date: date?.days ? date.days[day - 1].date : date,
                    products: newOrders,
                    type_id: type_id,
                },
            ],
            vendor_id: vendor.id,
        };

        getExcelExpoprt({
            method: "post",
            url: `/admin/v2/order/convert-excel/download`,
            data: newData,
        });
    };

    const saveBtnConvert = () => {
        const newData = {
            orders: [
                {
                    date: date?.days ? date.days[day - 1].date : date,
                    products: newOrders,
                    type_id: type_id,
                },
            ],
            vendor_id: vendor.id,
        };
        postSaveBtnConvertor({
            method: "post",
            url: "/admin/v2/order/convert",
            data: newData,
        });
    };

    const getTotal = (hubID) => {
        const currentIndex = totalValues.findIndex(
            (value) => value.hubID === hubID
        );
        return currentIndex > -1 ? totalValues[currentIndex]?.total : null;
    };

    return (
        <div style={{ width: "100%" }}>
            <Toast
                className="success"
                isShow={showToast.show}
                title={showToast.message}
            />
            <div className="table-wrapper-new">
                <table>
                    <thead>
                        <tr>
                            <th>
                                {vendorOrderType === 1
                                    ? "غذا"
                                    : isDry
                                      ? "بار خشک"
                                      : "مواد اولیه"}
                            </th>
                            {hubs.map((hub) => (
                                <Fragment key={hub.id}>
                                    {hasExcelExport ? (
                                        <th
                                            onClick={() =>
                                                exportToExcel(hub.id)
                                            }
                                        >
                                            {hub.title}
                                        </th>
                                    ) : (
                                        <th
                                            onClick={() =>
                                                setShowResetModal({
                                                    active: true,
                                                    type: "hub",
                                                    id: hub.id,
                                                })
                                            }
                                            key={hub.id}
                                        >
                                            {hub.title}
                                        </th>
                                    )}
                                </Fragment>
                            ))}
                            <th>مجموع</th>
                        </tr>
                    </thead>
                    <tbody>
                        {foods &&
                            foods.map((food, index) => (
                                <tr
                                    key={food.Title}
                                    onClick={() => setIsClicked(food.Title)}
                                >
                                    <th
                                        className={`${
                                            isClicked === food.Title
                                                ? "new-back"
                                                : " "
                                        }`}
                                        onClick={() =>
                                            setShowResetModal({
                                                active: true,
                                                type: "product",
                                                id: food.Items[0].product_id,
                                            })
                                        }
                                    >
                                        {food.Title}
                                    </th>
                                    <ExpandedRowDaily
                                        key={index}
                                        food={food}
                                        rowId={index}
                                        isClicked={isClicked === food.Title}
                                        defaultOrders={newOrders}
                                        hubsCount={hubs.length}
                                        hubs={hubs}
                                        isDisabled={
                                            userData[0].role ===
                                            "vendorproduction"
                                        }
                                        isUpdate={isUpdate}
                                        handleLogChange={logChangeOrders}
                                        totalRows={foods && foods.length}
                                        tableType={tableType}
                                    />
                                </tr>
                            ))}
                        {totalValues && (
                            <tr>
                                <th>مجموع</th>
                                {hubs.map((hub) => {
                                    return getTotal(hub.id) !== null ? (
                                        <td key={hub.id}>
                                            {toPersianNum(
                                                getTotal(hub.id),
                                                true
                                            )}
                                        </td>
                                    ) : (
                                        <td />
                                    );
                                })}
                                <td>
                                    {toPersianNum(
                                        handleMainColumnsTotal(),
                                        true
                                    )}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="table-fix-bar">
                {orders && (
                    <div className="d-flex align-items-center ml-auto">
                        {showTotalOrders && (
                            <Fragment>
                                <h6 className="ml-2 mb-0 font-size-16">
                                    مجموع سفارش‌های این وندور:
                                </h6>
                                <span className="font-weight-bold font-size-16 mb-1">
                                    {total !== null &&
                                        toPersianNum(total, true)}
                                </span>
                            </Fragment>
                        )}

                        {draftEnabled && (
                            <>
                                <div
                                    style={{
                                        height: "40px",
                                        marginInline: "14px",
                                        width: "1px",
                                        backgroundColor: "#B9BFCA",
                                    }}
                                />
                                <Button
                                    btnText={"ذخیره در پیش‌نویس"}
                                    className="is-green fw-bold border-0 p-0 m-0"
                                    handleClick={() => submitDraft()}
                                    disabled={disableLoadOldData}
                                />
                            </>
                        )}
                    </div>
                )}
                {showRedraftButton && (
                    <Button
                        btnText="بازگردانی به پیش نویس"
                        className="bordered is-green is-half-height"
                        handleClick={() => mutateBackToDraft(orderId)}
                        disabled={loading || BackToDraftLoading}
                        loading={loading || BackToDraftLoading}
                    />
                )}
                {directConfirm && (
                    <Button
                        btnText={
                            pathname.includes("offline")
                                ? "ثبت"
                                : "تایید و ثبت مستقیم"
                        }
                        className="is-green bordered is-half-height"
                        handleClick={() =>
                            handleSubmit({ direct_accept: true })
                        }
                        disabled={loading || BackToDraftLoading}
                        loading={loading || BackToDraftLoading}
                    />
                )}
                {confirmBtnText && (
                    <Button
                        btnText={confirmBtnText}
                        className="solid is-green is-half-height"
                        handleClick={() => handleSubmit()}
                        disabled={loading || BackToDraftLoading}
                        loading={loading || BackToDraftLoading}
                    />
                )}
                {isConvertPage && (
                    <Button
                        btnText={"ثبت"}
                        className="solid is-green is-half-height"
                        handleClick={() => saveBtnConvert()}
                        disabled={loadingSaveBtn || BackToDraftLoading}
                        loading={loadingSaveBtn}
                    />
                )}
                {exportExcelBtn && (
                    <Button
                        btnText={exportExcelBtn}
                        className="solid is-green is-half-height"
                        handleClick={exportConvertOrder}
                        disabled={loading || BackToDraftLoading}
                        loading={loading || BackToDraftLoading}
                    />
                )}
            </div>
            <Modal
                show={showResetModal?.active}
                onHide={() =>
                    setShowResetModal({ active: false, type: "", id: 0 })
                }
                className="rtl confirm-submit-order"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <>
                        <ButtonComponent
                            className="close-btn"
                            variant="secondary"
                            onClick={() =>
                                setShowResetModal({
                                    active: false,
                                    type: "",
                                    id: 0,
                                })
                            }
                        >
                            <CircleClose />
                        </ButtonComponent>
                        <ConfirmIcon className="confirm-logo" />
                        با انتخاب گزینه بله، تمامی داده های موجود در سطر یا ستون
                        انتخاب شده صفر خواهد شد! آیا مطمئن هستید؟
                    </>
                </Modal.Body>
                <div className="reset-modal-btn-wrap">
                    <Button
                        btnText="بله"
                        className={`solid is-green`}
                        handleClick={() =>
                            handleCloseResetModal(
                                showResetModal?.id,
                                showResetModal?.type
                            )
                        }
                    />
                    <Button
                        btnText="خیر"
                        className={`solid is-red`}
                        handleClick={() =>
                            setShowResetModal({
                                active: false,
                                type: "",
                                id: 0,
                            })
                        }
                    />
                </div>
            </Modal>
            <Modal
                show={showModal}
                onHide={() => {
                    handleRedirectToList();
                    toggleShowModal(false);
                }}
                className="rtl confirm-submit-order"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <>
                        <ButtonComponent
                            className="close-btn"
                            variant="secondary"
                            onClick={() => {
                                toggleShowModal(false);
                                handleRedirectToList();
                            }}
                        >
                            <CircleClose />
                        </ButtonComponent>
                        <ConfirmIcon className="confirm-logo" />
                        سفارش شما جهت بررسی به وندور مورد نظر ارسال شد. جهت
                        پیگیری وضعیت سفارش‌ها به صفحه در حال بررسی مراجعه کنید.
                    </>
                </Modal.Body>
                <div className="draft-btn-wrap">
                    <Button
                        btnText="متوجه شدم"
                        className={`solid is-green w-100`}
                        handleClick={() => handleRedirectToList()}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default KitchenExpandListDaily;
